import makeStorage from "./storage";

const rememberCredentials = makeStorage('credentials');
const authData = makeStorage('auth');
const filtersData = makeStorage('filters', 'sessionStorage');
const filtersVisible = makeStorage('filtersVisible', 'sessionStorage');
const establishmentOptions = makeStorage('establishment:options');
const listAdminModulesActions = makeStorage('listAdminModulesActions');

export {
    rememberCredentials,
    authData,
    filtersData,
    filtersVisible,
    establishmentOptions,
    listAdminModulesActions
}

